import { render, staticRenderFns } from "./AddThirdPartyWorks.vue?vue&type=template&id=d6f6efa6"
import script from "./AddThirdPartyWorks.vue?vue&type=script&lang=js"
export * from "./AddThirdPartyWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports